// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__BXe+w","grid_big":"Grid_grid_big__U9XFS"};